
const ProductionReport = () =>
    import("@/views/productionReport/ProductionReport");

export const ProductionReportRoute = {
    path: "/productionReport",
    component: ProductionReport,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",
        scope:["aps_broker","aps_executive"],
        breadcrumb: [
        {
            text: "",
            disabled: false,
            href: "#"
        }]
    }
};